import { RocheUIImage, RocheUIImageRatio } from '@repo/roche-ui';
import React, { FC } from 'react';
import { BlokToComponentProps } from '../../helpers/blok-to-component/types';
import { parseAssetSource } from '../../utils/asset';
import { AssetData } from '../../utils/asset/types';
import { Position } from '@rocheglobal/component-library-dot-com';

export interface RocheStoryblokAsset {
  src: AssetData;

  srcAltText?: string;

  /** videoloop id - overrides image if it exists and allows the videoloop to run */
  brightcove_id: string;

  /** Manage if title/ caption should be displayed */
  show_caption: boolean;

  /** Manage if copyright should be displayed */
  show_copyright: boolean;

  /** Image alt text - overrides any `alt` in the `src` prop if it is an ImageProp */
  alt: string;

  /** Image ratio */
  ratio: RocheUIImageRatio;

  /** Focus-point for image crop */
  position: Position;

  /** Ignore its container and make the image occupy the entire width */
  fullscreen: boolean;

  /** Allows the image to bleed 20% out of the grid */
  bleed: boolean;
}

type RocheImageProps = BlokToComponentProps<RocheStoryblokAsset>;

export const RocheImage: FC<RocheImageProps> = ({ blok, slot }) => {
  const assetData: AssetData = blok.src;
  const src = parseAssetSource(assetData.filename);
  const altText = assetData.alt !== undefined && assetData.alt !== '' ? assetData.alt : blok.srcAltText;

  if (blok.brightcove_id !== undefined && blok.brightcove_id !== null && blok.brightcove_id !== '') {
    return (
      <roche-image
        brightcove-id={blok.brightcove_id}
        caption={assetData.title}
        copyright={assetData.copyright}
        alt={altText}
        ratio={blok.ratio}
        slot={slot}
        position={blok.position}
        fullscreen={blok.fullscreen}
        showCaption={blok.show_caption}
        showCopyright={blok.show_copyright}
      />
    );
  } else if (src) {
    return (
      <RocheUIImage
        src={src}
        caption={assetData.title}
        copyright={assetData.copyright}
        alt={altText}
        ratio={blok.ratio}
        slot={slot}
        position={blok.position}
        fullscreen={blok.fullscreen}
        showCaption={blok.show_caption}
        showCopyright={blok.show_copyright}
        bleed={blok.bleed}
      />
    );
  }
  return null;
};
